const vpc = [
    {
        path: '/:project_id/vpc',
        name: 'vpc.index',
        component: () => import('@/pages/Cloud/VPS/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "VPS sotib olish",
        }
    },
    {
        path: '/:project_id/vpc/vps',
        name: 'vpc.vps.index',
        component: () => import('@/pages/Cloud/VPS/MyServersTab.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "VPS sotib olish",
        }
    },
    {
        path: '/:project_id/vpc/vps/create',
        name: 'vpc.vps.create',
        component: () => import('@/pages/Cloud/VPS/VpcPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "VPS sotib olish",
        }
    },
    {
        path: '/:project_id/vpc/vps/:id/show',
        name: 'vpc.vps.show',
        component: () => import('@/pages/Cloud/VPS/Show/ShowServer.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "VPS",
        }
    },
    {
        path: '/:project_id/vpc/volumes',
        name: 'vpc.volumes',
        component: () => import('@/pages/Page/PageSoon.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Volumes",
        }
    },
    {
        path: '/:project_id/vpc/networks/:tab',
        name: 'vpc.networks',
        component: () => import('@/pages/Cloud/Network/IndexPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Сеть",
            active_route: "vpc.networks",
        }
    },
    {
        path: '/:project_id/vpc/networks/vpc/:id',
        name: 'vpc.edit',
        component: () => import('@/pages/Cloud/VirtualPrivateCloud/EditPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            active_route: "vpc.networks",
            title: "VPC",
        }
    },
    {
        path: '/:project_id/vpc/firewalls',
        name: 'vpc.firewalls',
        component: () => import('@/pages/Cloud/Firewall/IndexPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Firewalls",
        }
    },
    {
        path: '/:project_id/vpc/firewalls/create',
        name: 'vpc.firewalls.create',
        component: () => import('@/pages/Cloud/Firewall/CreatePage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            active_route: "vpc.firewalls",
            layout: 'content',
            title: "Firewalls",
        }
    },
    {
        path: '/:project_id/vpc/firewalls/:id/edit',
        name: 'vpc.firewalls.edit',
        component: () => import('@/pages/Cloud/Firewall/EditPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Firewalls",
            active_route: "vpc.firewalls",
        }
    },
    {
        path: '/:project_id/vpc/images',
        name: 'vpc.images',
        component: () => import('@/pages/Page/PageSoon.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Profil sozlamalari",
        }
    },
    {
        path: '/:project_id/vpc/disks',
        name: 'vpc.disks',
        component: () => import('@/pages/Cloud/Disk/Index.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Диски",
        }
    },
    {
        path: '/:project_id/vpc/disks/:id/edit',
        name: 'vpc.disks.edit',
        component: () => import('@/pages/Cloud/Disk/EditPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Диски",
        }
    },
    {
        path: '/:project_id/vpc/backups',
        name: 'vpc.backups',
        component: () => import('@/pages/Page/PageSoon.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Profil sozlamalari",
        }
    },
    {
        path: '/:project_id/vpc/object-storages',
        name: 'vpc.object_storages',
        component: () => import('@/pages/ObjectStorage/IndexPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "pages.object_storages.containers.title",
        }
    },
    {
        path: '/:project_id/vpc/object-storages/:id/show',
        name: 'vpc.object_storages.show',
        component: () => import('@/pages/ObjectStorage/EditPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "pages.object_storages.containers.title",
        }
    },
]

export default vpc